import {
  Configuration,
  ConsumersApi,
  SubscriptionsApi,
} from '@/api/bol-notifications';
import { oAuthService } from './oAuthService';

/**
 * Singleton factory for BOL Notifications API clients
 */
class BolNotificationsApiClientFactory {
  private consumersApi: ConsumersApi | null = null;
  private subscriptionsApi: SubscriptionsApi | null = null;

  private getConfiguration(): Configuration {
    return new Configuration({
      basePath: '/notifications-api',
      accessToken: async () => {
        try {
          const token = await oAuthService.getAccessToken();
          return `Bearer ${token}`;
        } catch (error) {
          console.error('[bolNotificationsApiClient] Failed to get access token:', error);
          throw error;
        }
      },
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    });
  }

  getConsumersApi(): ConsumersApi {
    if (!this.consumersApi) {
      this.consumersApi = new ConsumersApi(this.getConfiguration());
    }
    return this.consumersApi;
  }

  getSubscriptionsApi(): SubscriptionsApi {
    if (!this.subscriptionsApi) {
      this.subscriptionsApi = new SubscriptionsApi(this.getConfiguration());
    }
    return this.subscriptionsApi;
  }

  reset(): void {
    this.consumersApi = null;
    this.subscriptionsApi = null;
  }
}

const factory = new BolNotificationsApiClientFactory();

export function getSubscriptionsApi(): SubscriptionsApi {
  return factory.getSubscriptionsApi();
}

export function getConsumersApi(): ConsumersApi {
  return factory.getConsumersApi();
}

export function resetBolNotificationsApiInstances(): void {
  factory.reset();
}
